/** Panel class for a section Bootstrap used to open and close. Not collapsible: no collapse class, so the panel stays visible. */
export function disclosurePanelClass(canCollapse: boolean, open: boolean): string {
    if (!canCollapse) return '';
    return open ? 'collapse show' : 'collapse';
}
